// Get cart from localStorage
export const getCart = () => {
  const cart = localStorage.getItem('cart');
  return cart ? JSON.parse(cart) : { items: [], totalQuantity: 0, totalAmount: 0 };
};

// Save cart to localStorage
export const saveCart = (cart) => {
  localStorage.setItem('cart', JSON.stringify(cart));
};

// Add item to cart
export const addToCart = (book) => {
  const cart = getCart();
  const existingItem = cart.items.find(item => item.id === book.id);
  
  if (existingItem) {
    existingItem.quantity += 1;
    existingItem.totalPrice = existingItem.quantity * existingItem.price;
  } else {
    cart.items.push({
      ...book,
      quantity: 1,
      totalPrice: book.price
    });
  }
  
  cart.totalQuantity = cart.items.reduce((total, item) => total + item.quantity, 0);
  cart.totalAmount = cart.items.reduce((total, item) => total + item.totalPrice, 0);
  
  saveCart(cart);
  return cart;
};

// Remove item from cart
export const removeFromCart = (bookId) => {
  const cart = getCart();
  const existingItem = cart.items.find(item => item.id === bookId);
  
  if (existingItem) {
    if (existingItem.quantity === 1) {
      cart.items = cart.items.filter(item => item.id !== bookId);
    } else {
      existingItem.quantity -= 1;
      existingItem.totalPrice = existingItem.quantity * existingItem.price;
    }
    
    cart.totalQuantity = cart.items.reduce((total, item) => total + item.quantity, 0);
    cart.totalAmount = cart.items.reduce((total, item) => total + item.totalPrice, 0);
    
    saveCart(cart);
  }
  
  return cart;
};

// Clear cart
export const clearCart = () => {
  const emptyCart = { items: [], totalQuantity: 0, totalAmount: 0 };
  saveCart(emptyCart);
  return emptyCart;
};
